import { Box } from '@coolblue-development/freddy';
import isPropValid from '@emotion/is-prop-valid';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
export const AnimatedBannerProgressBar = styled('div', {
    shouldForwardProp: prop => isPropValid(prop),
}) `
  flex: 1;
  height: 0.3rem;
  overflow: hidden;
  border-radius: 0.15rem;
  position: relative;
  background-color: ${({ theme }) => theme.color.background.tertiary};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: ${({ currentSlide, barPosition }) => (barPosition < currentSlide ? '100%' : '0')};
    height: 100%;
    background-color: ${({ theme }) => theme.color.background.primary};
    animation: ${({ startLoading, barPosition, currentSlide }) => startLoading && barPosition === currentSlide ? animateProgressBar() : 'none'}
      5s linear;
  }
`;
const animateProgressBar = () => keyframes `
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
`;
export const MobileBannersWrapper = styled(Box) `
  overflow-x: hidden;
  width: 100vw;
  margin-left: ${({ theme }) => `calc(-1 * ${theme.spacing[500]})`};
`;
export const MobileBannersContainer = styled(Box) `
  display: flex;
  gap: ${({ theme }) => theme.spacing[400]};
  position: relative;
  animation-delay: 5s;
  overflow-x: scroll;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
`;
export const MobileBanner = styled.div `
  position: relative;
  min-width: 100vw;
  overflow: hidden;
  scroll-snap-align: start;

  img {
    width: 100%;
    height: auto;
  }
`;
//# sourceMappingURL=HomepageBanners.styled.js.map